export enum WidgetType {
   UnclaimedTasks = 1,
   Mention = 2,
   FollowUp = 3,
   ClaimedTasks = 4
}
